﻿import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { User } from '../_models';
import { UtilsService } from './../_services/utils.service';
@Injectable()
export class UserService {
    constructor(private http: HttpClient, private _utilsService: UtilsService) { }

    getAll() {
        return this.http.get<User[]>(`${environment.apiUrl}/users`);
    }

    getById(id: number) {
        return this.http.get(`${environment.apiUrl}/users/` + id);
    }

    register(user: User) {
        return this.http.post(`${environment.apiUrl}/users/register`, user);
    }

    update(user: User) {
        return this.http.put(`${environment.apiUrl}/users/` + user.id, user);
    }

    delete(id: number) {
        return this.http.delete(`${environment.apiUrl}/users/` + id);
    }
    getAllRefferals(user_id){
        return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/getAllRefferals/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + user_id);
    }
    checkRefferals(referalCode){
        return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/checkReferral/' + `${environment.DRAFT_ACCESS_TOKEN}` + '/' + referalCode);
    }
    saveRefferals(referralCode,user_id){
        var data = {
            "referral_code":referralCode,
            "user_id":user_id
          };
          return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user/update_user_detail/', data, null, 'content-type-json');
    }
    sendRefferals(email){
        var data = {
            "email":email
          };
          return this._utilsService.postRequest(`${environment.phpApiUrl}` + '/user/mailForRefferFriend/', data, null, 'content-type-json');
    }

    checkSpecialReferCode(){
        return this._utilsService.getRequest(`${environment.phpApiUrl}` + '/user/check-special-refer-code');
    }
}
